import React from "react";
import {ReportContainer} from "./ReportContainer";
import {Banner} from "./Banner";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

export class App extends React.Component {

   render() {
        return (
                <div id="root">
                    <Banner />
                    <AuthenticatedTemplate>
                        <ReportContainer />
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <p>You are not signed in! Please sign in.</p>
                    </UnauthenticatedTemplate>
                </div>
        );
    }
}